<template>
	<div class="deat_box ">
		<div class="box_center"><el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" placeholder="请输入内容" v-model="textarea"></el-input></div>
		<div class="p_flex p_f_e p_m_t_20"><el-button type="success">发送</el-button></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			textarea: ''
		};
	},
	mounted() {},
	methods: {}
};
</script>

<style lang="scss" scoped>
.deat_box {
	padding: 20px 260px 0;
}
.box_center {
	background-color: #f5f5f5;
	border-radius: 20px;
}
>>> .el-textarea__inner {
	border: none;
	background-color: #f5f5f5;
	padding: 20px;
	font-size: 16px;
	border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/news/commponents/errorInput.vue